import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../ui/Card';

interface GroupCardProps {
  id: string;
  name: string;
  description?: string;
  memberCount: number;
  lastActivity?: string;
}

export const GroupCard: React.FC<GroupCardProps> = ({
  id,
  name,
  description,
  memberCount,
  lastActivity,
}) => {
  const navigate = useNavigate();

  const getGroupEmoji = (name: string): string => {
    const lowerName = name.toLowerCase();
    if (lowerName.includes('trip') || lowerName.includes('vacation')) return '✈️';
    if (lowerName.includes('dinner') || lowerName.includes('lunch') || lowerName.includes('food')) return '🍽️';
    if (lowerName.includes('party')) return '🎉';
    if (lowerName.includes('office') || lowerName.includes('work')) return '💼';
    if (lowerName.includes('home') || lowerName.includes('flat') || lowerName.includes('roommate')) return '🏠';
    if (lowerName.includes('friend')) return '👥';
    if (lowerName.includes('family')) return '👨‍👩‍👧‍👦';
    return '📋';
  };

  return (
    <Card
      hover
      onClick={() => navigate(`/groups/${id}`)}
      className="cursor-pointer"
    >
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 bg-slate-100 rounded-xl flex items-center justify-center text-2xl flex-shrink-0">
          {getGroupEmoji(name)}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-slate-900 truncate">{name}</h3>
          {description && (
            <p className="text-sm text-slate-500 truncate mt-0.5">{description}</p>
          )}
          <div className="flex items-center gap-3 mt-2 text-xs text-slate-400">
            <span className="flex items-center gap-1">
              <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
              </svg>
              {memberCount} {memberCount === 1 ? 'person' : 'people'}
            </span>
            {lastActivity && (
              <span>{lastActivity}</span>
            )}
          </div>
        </div>
        <svg className="w-5 h-5 text-slate-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </Card>
  );
};

export default GroupCard;
